<template>
  <div>
    <div class="live-container">
      <div class="card-wrapper">
        <div class="card-title-wrapper">
          <div class="card-title">
            <h1>Congratulations! Just one final check…</h1>
          </div>
          <div class="h3 card-subtitle">
            Are you ready to launch your eStore website and start selling?
            <br />
            Please nominate your subdomain.
          </div>
        </div>
        <b-container class="w-75">
          <b-form-group>
            <template slot="label">
              <small>
                <span>Access Link</span>
                <span class="text-danger ml-1">*</span>
              </small>
            </template>
            <div>
              <b-input-group class="subdomain-input-group">
                <b-input-group-text slot="prepend">
                  <b-img
                    :src="require('@/assets/images/icons/link.svg')"
                    alt="Link"
                  />
                </b-input-group-text>
                <b-input-group-text class="bg-light" slot="prepend">
                  {{ estoreWebDomain }}
                </b-input-group-text>
                <b-input
                  v-model="subdomain"
                  class="border-right-0"
                  :maxlength="subdomainMaxLength"
                  autocomplete="off"
                  @keypress.native="filterSubdomainKeypress"
                  @paste.prevent
                />
                <b-input-group-text
                  slot="append"
                  :class="{
                    'text-danger': hasSubdomainErrors,
                  }"
                >
                  <small v-if="hasCheckedSubdomainAvailability">
                    {{ isExistingSubdomain ? "Unavailable" : "Available" }}
                  </small>
                  <small v-if="subdomainMinLengthNotMet">
                    Must be least {{ subdomainMinLength }} characters
                  </small>
                </b-input-group-text>
              </b-input-group>
              <div class="character-count">
                {{ subdomain.length }} / {{ subdomainMaxLength }}
              </div>
            </div>
          </b-form-group>
        </b-container>

        <div class="btn-wrapper">
          <div @click="closeModal">No, I need to make adjustments</div>
          <button
            @click="startSelling"
            class="card-btn"
            :disabled="isLoading || hasSubdomainErrors"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import _ from "lodash";

export default {
  data() {
    return {
      env: process.env.VUE_APP_MODE,
      subdomain: "",
      subdomainMinLength: 5,
      subdomainMaxLength: 30,
      hasCheckedSubdomainAvailability: false,
      estoreWebDomains: {
        Development: "http://estore-web-development.loyaltyco.xyz",
        Canary: "http://estore-web-canary.loyaltyco.xyz",
        Staging: "http://estore-web-staging.loyaltyco.xyz",
        Release: "http://estore-web-release.loyaltyco.xyz",
        Production: "https://estore.rush.ph",
      },
    };
  },
  computed: {
    ...mapState("onboarding", [
      "startSellingModal",
      "isExistingSubdomain",
      "isLoading",
      "errors",
    ]),
    ...mapGetters("accountProfile", ["liveSubdomain"]),
    subdomainMinLengthNotMet() {
      return this.subdomain && this.subdomain.length < this.subdomainMinLength;
    },
    hasSubdomainErrors() {
      return (
        !this.subdomain.length ||
        this.isExistingSubdomain ||
        this.subdomainMinLengthNotMet
      );
    },
    estoreWebDomain() {
      return this.estoreWebDomains[this.env];
    },
  },
  methods: {
    closeModal() {
      this.$store.commit("onboarding/setStartSellingModal", false);
    },
    async startSelling() {
      if (!this.hasSubdomainErrors) {
        await this.$store.dispatch(
          "onboarding/updateSubdomain",
          this.subdomain
        );

        if (_.isEmpty(this.errors)) {
          await this.$store.dispatch("onboarding/goLiveWebsite");
          this.$store.commit("onboarding/setStartSellingModal", false);
          window.open(`${this.estoreWebDomain}/${this.subdomain}`, "_blank");
        }
      }
    },
    filterSubdomainKeypress(e) {
      if (/[^A-Za-z0-9_-]+/g.test(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
  },
  async created() {
    this.checkSubdomainAvailability = _.debounce(() => {
      if (this.subdomain)
        this.$store.dispatch("onboarding/checkSubdomain", this.subdomain);
    }, 500);

    await this.$store.dispatch("accountProfile/assignMerchantDetail");

    this.subdomain = this.liveSubdomain;
  },
  watch: {
    subdomain(value) {
      if (value.length >= this.subdomainMinLength) {
        this.checkSubdomainAvailability();
        this.hasCheckedSubdomainAvailability = true;
      } else this.hasCheckedSubdomainAvailability = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-wrapper {
  margin-top: 15px;
  color: #87929d;
  font-family: MainFontRegular, sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: solid 1px #e9ebed;
  width: 100%;
  padding: 11px;

  div {
    cursor: pointer;
  }

  .card-btn {
    margin-left: 20px;
    border-radius: 8px;
    background: #53b6b2;
    display: flex;
    height: 40px;
    padding: 15px 25px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    color: #fff;
    font-family: MainFontRegular, sans-serif;
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    border: none;
    &:disabled {
      opacity: 0.5;
    }
  }
}

.live-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background-color: #fff;
  width: 750px;
}

.card-icon {
  margin-top: 13px;
  margin-bottom: 17px;
}

.card-title-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0px;
}

.card-subltitle {
  display: flex;
  justify-content: center;
  margin-bottom: 0px;
}

.card-title {
  margin-bottom: 0px;

  h1 {
    color: #2f3941;
    text-align: center;
    font-family: MainFontRegular, sans-serif;
    font-size: 18px;
    font-style: normal;
    line-height: 22px;
    margin-bottom: 21px;
    margin-top: 33px;
  }
}

.card-subtitle {
  margin: 0px;
  color: #49545c;
  text-align: center;
  font-family: MainFontRegular, sans-serif;
  font-size: 13px;
  font-style: normal;
  line-height: 20px;
  margin-bottom: 20px;
  padding: 0px 35px;
}
.subdomain-input-group {
  font-family: MainFontRegular, sans-serif;
  .form-control:focus {
    border-color: #ced4da;
  }
  .input-group-append .input-group-text {
    color: #4bd37b;
    font-size: 12px;
    background: #ffffff;
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 0.25rem;
    border-left: 0;
  }
}

.character-count {
  margin-top: 5px;
  text-align: right;
  font-size: 11px;
  color: #6c757d;
}
</style>